var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Dropzone from "react-dropzone";
import styled from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import getBase64 from "@irati/utils/images/getBase64";
import { BRAND_LOGO_DIMENSIONS } from "@irati/brand/constants/brand";
import { H1, Body } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
import DropZoneWrapper from "./styled/DropZoneWrapper";
import DropZoneImg from "./styled/DropZoneImg";
import add_a_file from "./add-a-file.png";
var UnderlineStrong = styled.strong(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: underline;\n  cursor: pointer;\n"], ["\n  text-decoration: underline;\n  cursor: pointer;\n"])));
var UploadLogoStep = /** @class */ (function (_super) {
    __extends(UploadLogoStep, _super);
    function UploadLogoStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadLogoStep.prototype.onFileDropped = function (acceptedFile, rejectedFile) {
        var _this = this;
        if (rejectedFile.length > 0) {
            console.error("REJECTED FILE");
            return;
        }
        var file = acceptedFile[0];
        getBase64(file).then(function (contents) {
            _this.props.onComplete(file, contents);
        });
    };
    UploadLogoStep.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(H1, { marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "admin.components.updateLogoStep.title" })),
            React.createElement(Body, null,
                React.createElement(FormattedMessage, { id: "admin.components.updateLogoStep.subTitle", values: { width: BRAND_LOGO_DIMENSIONS.width * 2, height: BRAND_LOGO_DIMENSIONS.height * 2 } })),
            React.createElement(DropZoneWrapper, null,
                React.createElement(Dropzone, { className: "logo-drop-zone", name: "fieldname", accept: "image/jpg,image/jpeg,image/png", multiple: false, onDrop: this.onFileDropped.bind(this) },
                    React.createElement(Flex, { justifyContent: "center", alignItems: "center", height: "100%", className: "drop-contents" },
                        React.createElement(DropZoneImg, { src: add_a_file }),
                        React.createElement(Body, null,
                            React.createElement(FormattedMessage, { id: "admin.components.updateLogoStep.headerFour", values: { browse: React.createElement(UnderlineStrong, null,
                                        React.createElement(FormattedMessage, { id: "admin.components.updateLogoStep.header.browse" })) } })))))));
    };
    return UploadLogoStep;
}(PureComponent));
export default UploadLogoStep;
var templateObject_1;
